import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API ?? '';
const inviteCompanyMember = 'company/invite-member';
const listCompanyMember = 'company/member';
const getDetailCompany = 'company/detail';
const updateCompany = 'company/update';
const deleteCompanyMember = 'company/delete-member';

export interface InviteMemberPayload {
  readonly email: string;
}

export interface ApiResponse<TData> {
  readonly data: TData;
  readonly message: string;
}

export const apiInviteCompanyMember = async (val: InviteMemberPayload): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + inviteCompanyMember}`, val);
  return datas.data;
};

export const apiListCompanyMember = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + listCompanyMember}`, val);
  return datas.data.data;
};

export const apiDetailCompany = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + getDetailCompany}`, val);
  return datas.data.data;
};

export const apiUpdateCompany = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + updateCompany}`, val);
  return datas.data;
};

// Keep rest as-is for now since we're focusing on member management
const copList = 'company-setting/list-custom-param';
const copCreate = 'company-setting/create-custom-param';
const copUpdate = 'company-setting/update-custom-param';
// setting - custom org parameter
const customManagementList = 'wla-adhoc-group/list';
const customManagementCreate = 'wla-adhoc-group/create';
const customManagementUpdate = 'wla-adhoc-group/update';
const competencyLibList = 'competency/list';
const competencyLibCreate = 'competency/create';
const competencyLibUpdate = 'competency/update';
// setting - level description
const listLevelDescription = 'custom-jobdesc/list';
const createLevelDescription = 'custom-jobdesc/create';
const updateLevelDescription = 'custom-jobdesc/update';
// setting - competeny lib import
const importCompetencyLib = 'competency/import';
const competencyMove = 'competency/move';
const inquiry = 'competency/inquiry';
const competencyDelete = 'competency/delete';
const detailCompetency = 'competency/detail';
// setting - activity
const moveOrderActivity = 'wla/move-activity-type';
// setting - fteLimit
const moveOrderFteLimit = 'wla/move-fte-limit';
// setting - skill group management
const listSkillGroup = 'competency-skill-group/list';
const listSubSkillGroup = 'competency-sub-skill-group/list';
const addSkillGroup = 'competency-sub-skill-group/add-bulk';

export const apiCopList = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + copList}`, val);
  return datas.data.data;
};

export const apiCopCreate = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + copCreate}`, val);
  return datas.data.data;
};

export const apiCopUpdate = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + copUpdate}`, val);
  return datas.data.data;
};

export const apiDeleteCompanyMember = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + deleteCompanyMember}`, val);
  return datas.data;
};

export const apiCustomManagement = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + customManagementList}`, val);
  return datas.data.data;
};

export const apiCustomManagementCreate = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + customManagementCreate}`, val);
  return datas.data;
};

export const apiCustomManagementUpdate = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + customManagementUpdate}`, val);
  return datas.data;
};

export const apiCompetencyLib = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + competencyLibList}`, val);
  return datas.data.data;
};

export const apiCompetencyLibCreate = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + competencyLibCreate}`, val);
  return datas.data;
};

export const apiCompetencyLibUpdate = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + competencyLibUpdate}`, val);
  return datas.data;
};

export const apiListLevelDesc = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + listLevelDescription}`, val);
  return datas.data.data;
};

export const apiCreateLevelDesc = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + createLevelDescription}`, val);
  return datas.data;
};

export const apiUpdateLevelDesc = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + updateLevelDescription}`, val);
  return datas.data;
};

export const apiImportCompetencyLib = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + importCompetencyLib}`, val);
  return datas.data;
};

export const apiMoveOrderActivity = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + moveOrderActivity}`, val);
  return datas.data;
};

export const apiMoveOrderFteLimit = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + moveOrderFteLimit}`, val);
  return datas.data;
};

export const apiCompetencyMove = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + competencyMove}`, val);
  return datas.data;
};

export const apiCompetencyDelete = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + competencyDelete}`, val);
  return datas.data;
};

export const apiDetailCompetency = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + detailCompetency}`, val);
  return datas.data;
};

export const apiCompetencyInquiry = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + inquiry}`, val);
  return datas.data;
};

export const apiSkillGroupList = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + listSkillGroup}`, val);
  return datas.data;
};

export const apiSubSkillGroupList = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + listSubSkillGroup}`, val);
  return datas.data;
};

export const apiSkillGroupAdd = async (val: unknown): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + addSkillGroup}`, val);
  return datas.data;
};
